export default "__VITE_ASSET__m3N5IQe6__"